import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as modalDataService from "./modalDataService";
import * as domainService from "./domainService";
import { sortObjectsByAlphabet } from "../../utils";
import SelectV2 from "../../view/SelectV2";

function DomainField({ domains = [], domainId, domainSet }) {

    const disabled = !domainSet;
    const fetchData = async () => {
        if (!domains || domains.length === 0) {
            domainService.list()
                .then((data) =>
                    !domainId && data
                   // && modalDataService.changeDomain(data.find(domain => domain.id === Number(data[0].id)))
                    && modalDataService.changeDomain({ id: -1, name: "Choose" })
                    );
        }
        else {

        }
        
    }
    useEffect(() => {
        fetchData();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, [])

    const onChange = (value) => {
        const domain = domains.find(domain => String(domain.id) === String(value));
        modalDataService.changeDomain(domain)
    };

    const domainsCopy = sortObjectsByAlphabet(domains, 'name');
    const domainOptions = domainsCopy.map((domain) => ({
        value: domain.id,
        label: domain.name
    }));

    return (
        <div className="form-group">
            <div className="oct_form-group">
                <label htmlFor="domain">Domain <span className="modal-v2-required-mark">*</span></label>
                <SelectV2
                    inputId="domain"
                    value={domainId}
                    onChange={onChange}
                    options={domainOptions}
                    isDisabled={disabled}
                    placeholder="Choose"
                />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("DomainField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const domain = addDeviceModal.domain;
    return {
        domains: addDeviceModal.domains || [],
        domainId: domain ? domain.id : null,
        domainSet: addDeviceModal.domainSet,
    };
}

export default connect(mapStateToProps)(DomainField);
